import { createContext, ReactNode, useContext } from 'react';
import { createPortal } from 'react-dom';

/**
 * The element on the right of the top bar that pages may render into.
 *
 * `null` until the top bar has mounted, which includes the whole server render
 * and the first client render, so hydration sees nothing on either side.
 */
export const TopbarSlotContext = createContext<HTMLElement | null>(null);

/**
 * Renders `children` into the top bar, beside the user menu.
 *
 * A portal rather than state lifted into `RootLayout`, so each page keeps its
 * own rule for when its control applies (the experience toggle depends on the
 * model's type and on whether this person opted out, which only the page knows).
 */
export function TopbarSlot({ children }: { children: ReactNode }) {
  const slot = useContext(TopbarSlotContext);
  return slot ? createPortal(children, slot) : null;
}
